module.exports = __webpack_public_path__ + "img/box2_bg.9084df2c.png";